// Film grain over everything. Fixed, non-interactive, faint. Hidden under reduced motion via CSS.
export default function Grain() {
  return <div className="film-grain" aria-hidden="true" />;
}
